var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtherscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14096_25759)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14096_25759",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14096_25759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19813 9.49926C4.19815 9.38882 4.21999 9.27949 4.26238 9.1775C4.30477 9.07554 4.36688 8.98295 4.44516 8.90505C4.52345 8.82715 4.61633 8.76547 4.71851 8.72357C4.82069 8.68167 4.93013 8.66036 5.04057 8.66088L6.43732 8.66544C6.66 8.66544 6.87358 8.75391 7.03104 8.91137C7.18852 9.06884 7.277 9.28241 7.277 9.50511V14.7864C7.43423 14.7397 7.63618 14.69 7.85716 14.638C8.01065 14.6019 8.14745 14.515 8.24537 14.3915C8.34327 14.2679 8.39654 14.1148 8.39651 13.9571V7.40593C8.39651 7.18321 8.48496 6.96962 8.64243 6.81212C8.79989 6.65462 9.01347 6.56614 9.23618 6.56609H10.6357C10.8584 6.56614 11.072 6.65462 11.2294 6.81212C11.3869 6.96962 11.4754 7.18321 11.4754 7.40593V13.4861C11.4754 13.4861 11.8258 13.3443 12.1671 13.2002C12.2939 13.1466 12.4021 13.0569 12.4782 12.9421C12.5543 12.8274 12.5949 12.6929 12.595 12.5552V5.30674C12.595 5.08407 12.6835 4.87051 12.8409 4.71305C12.9983 4.55558 13.2119 4.46711 13.4345 4.46706H14.8341C15.0568 4.46706 15.2703 4.55552 15.4278 4.713C15.5853 4.87046 15.6737 5.08404 15.6737 5.30674V11.2757C16.8871 10.3963 18.1167 9.33877 19.0924 8.06706C19.2341 7.88248 19.3277 7.66571 19.3651 7.43614C19.4025 7.20656 19.3825 6.97128 19.3069 6.75129C18.8552 5.45175 18.1373 4.26079 17.1989 3.25464C16.2606 2.24851 15.1225 1.44933 13.8576 0.90827C12.5926 0.36721 11.2287 0.0961756 9.85295 0.112513C8.47724 0.128851 7.1201 0.432202 5.86838 1.00315C4.61664 1.5741 3.49787 2.40007 2.58368 3.42822C1.66948 4.45635 0.97999 5.66402 0.559321 6.97394C0.138654 8.28384 -0.00392407 9.66715 0.14071 11.0353C0.285344 12.4035 0.714007 13.7264 1.39926 14.9194C1.51864 15.1252 1.69426 15.2927 1.9055 15.4021C2.11673 15.5116 2.35482 15.5585 2.59179 15.5373C2.85651 15.5141 3.1861 15.481 3.57797 15.435C3.74856 15.4157 3.90605 15.3342 4.02044 15.2062C4.13485 15.0782 4.19815 14.9126 4.1983 14.7409L4.19813 9.49926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16805 17.97C5.64322 19.0432 7.38655 19.6874 9.20514 19.8313C11.0237 19.975 12.8467 19.6131 14.4723 18.7851C16.0979 17.9572 17.4627 16.6957 18.4158 15.1402C19.3688 13.5847 19.8731 11.7959 19.8726 9.97157C19.8726 9.74393 19.862 9.51873 19.8469 9.29483C16.234 14.6831 9.56333 17.2022 4.16836 17.9692",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14096_25759)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.00390625,
    y: 0.000976562,
    width: 20,
    height: 20,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14096_25759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00390625 0.000976562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14096_25759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00390625 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherscan);
export default __webpack_public_path__ + "static/media/etherscan.285ea88c9b9da80a408c0e0a7b64c2e1.svg";
export { ForwardRef as ReactComponent };